var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM10.3839 8.61612C9.89573 8.12796 9.10427 8.12796 8.61612 8.61612C8.12796 9.10427 8.12796 9.89573 8.61612 10.3839L10.2322 12L8.61612 13.6161C8.12796 14.1043 8.12796 14.8957 8.61612 15.3839C9.10427 15.872 9.89573 15.872 10.3839 15.3839L12 13.7678L13.6161 15.3839C14.1043 15.872 14.8957 15.872 15.3839 15.3839C15.872 14.8957 15.872 14.1043 15.3839 13.6161L13.7678 12L15.3839 10.3839C15.872 9.89573 15.872 9.10427 15.3839 8.61612C14.8957 8.12796 14.1043 8.12796 13.6161 8.61612L12 10.2322L10.3839 8.61612Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCancel);
export default __webpack_public_path__ + "static/media/black-cancel.70f0ce0c4e5881a9959e7173d6ab7b42.svg";
export { ForwardRef as ReactComponent };